import uid from '@/utils/simpleuid'
import store from '@/store'

export default {
  // updated () {
  //   console.log('updated -> displayChanged')
  //   this.$emit('displayChanged')
  // },
  data () {
    const data = {
      elementUid: uid()
    }

    console.debug('Initializing base component [elementUid = ' + data.elementUid)

    return data
  },
  mounted () {
    console.debug('mounted -> displayChanged')
    this.$emit('displayChanged')
    store.timer.display = this.displayTimer
  }
}
